import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useModal } from "@/modals"
import { Button } from "@/ui/Button"
import { Modal } from "@/ui/Modal"
import styles from "./AuthRedirectModal.module.scss"

const modalType = "authRedirectModal"

export const AuthRedirectModal: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { modal, getModalParams } = useModal(modalType)
  const { mode, email } = getModalParams(modalType)!

  const handlePrimary = () => {
    modal.close()
    navigate(mode === "toLogin" ? "/login" : "/register", {
      state: { prefillEmail: email }
    })
  }

  return (
    <Modal.Center type={modalType}>
      <Modal.StoneFlexContainer>
        <div className={styles.AuthRedirectModal}>
          <div className={styles.AuthRedirectModal_title}>
            {t(`authRedirectModal.${mode}.title`)}
          </div>
          <div className={styles.AuthRedirectModal_description}>
            {t(`authRedirectModal.${mode}.description`)}
          </div>
          <div className={styles.AuthRedirectModal_buttons}>
            <Button styles="green" onClick={modal.close}>
              {t("authRedirectModal.close")}
            </Button>
            <Button onClick={handlePrimary}>
              {t(`authRedirectModal.${mode}.primaryCta`)}
            </Button>
          </div>
        </div>
      </Modal.StoneFlexContainer>
    </Modal.Center>
  )
}
